//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LinkedApplicationItem from "./linked-application-item.vue";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "StarredLinkedApplication",
  components: {
    LinkedApplicationItem,
    CollapsibleCard
  },
  props: {
    application: {
      type: Object,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleSave() {
      this.$emit("save");
    },
    handleCopyApplication(application) {
      this.$emit("copy-application", application);
    }
  }
});